import React, { useEffect, useMemo, useContext } from "react";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";
import CommunicationsTable from "./CommunicationTable";
import TableSkeleton from "./Skeleton";
import * as communicationActions from "../../redux/actions/communicationActions";
import { useFeatureFlag } from "../../context/features";
import { Card } from "@pushpress/pushpress-ui";
import { MailCheck } from "lucide-react";

const mapDispatchToProps = {
  ...communicationActions,
};
function Automatic({ fetchTriggers, updateTrigger, updateTriggerBulk }) {
  const { isFeatureEnabled } = useFeatureFlag();

  useEffect(() => {
    fetchTriggers();
  }, [fetchTriggers]);

  const triggers = useSelector((state) => state.communications.data);

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "shortDescription",
        displayName: "Email Trigger",
      },
      {
        Header: "Category",
        accessor: "category",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Event ID",
        accessor: "id",
      },
      {
        Header: "content",
        accessor: "longDescription",
      },
      {
        Header: "activityEventName",
        accessor: "activityEventName",
      },
    ],
    [],
  );

  const availableCommunicationTriggers = useMemo(() => {
    return triggers.filter((trigger) => {
      if (!trigger.featureFlag) return true;

      return isFeatureEnabled(trigger.featureFlag);
    });
  }, [triggers, isFeatureEnabled]);

  if (!availableCommunicationTriggers?.length) return <TableSkeleton />;

  return (
    <div className="tw-flex tw-flex-col md:tw-px-8 md:tw-pt-4 tw-w-full tw-mx-auto tw-max-w-7xl">
      <div className="tw-mb-4 tw-flex tw-flex-col">
        <h3 className="tw-pb-4">Automatic Emails</h3>

        <Card className="tw-p-4">
          <div className="tw-flex tw-items-center tw-gap-4">
            <div>
              <div className="tw-rounded-full tw-bg-blue-50 tw-border tw-border-blue-100 tw-p-2">
                <MailCheck className="tw-w-8 tw-h-8 tw-text-gray-600" />
              </div>
            </div>
            <div>
              <p className="tw-text-sm tw-text-gray-600 tw-mb-1">
                Keep your gym running smoothly with automated updates about members, payments, and staff. Toggle any alert on or off as needed.
              </p>
              <p className="tw-text-sm tw-text-gray-500">
                Learn more about these <a href="https://help.pushpress.com/en/articles/5593053-core-system-emails" target="_blank" rel="noopener noreferrer" className="tw-text-blue-600 hover:tw-underline">email triggers</a>
              </p>
            </div>
          </div>
        </Card>
      </div>
      <CommunicationsTable
        updateTrigger={updateTrigger}
        updateTriggerBulk={updateTriggerBulk}
        columns={columns}
        data={availableCommunicationTriggers}
      />
    </div>
  );
}

Automatic.propTypes = {
  fetchTriggers: PropTypes.func.isRequired,
  updateTrigger: PropTypes.func.isRequired,
  updateTriggerBulk: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(Automatic);
